import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export function getCodeBidiWarningDomSpec(bidiCharacter, codeBidiWarningLabel, tooltipEnabled) {
  var _bidiCharacter$codePo;
  var bidiCharacterCode = "U+".concat((_bidiCharacter$codePo = bidiCharacter.codePointAt(0)) === null || _bidiCharacter$codePo === void 0 || (_bidiCharacter$codePo = _bidiCharacter$codePo.toString(16)) === null || _bidiCharacter$codePo === void 0 ? void 0 : _bidiCharacter$codePo.toUpperCase());
  return ['span', {
    'data-prosemirror-node-name': 'code-bidi-warning',
    dir: 'ltr'
  },
  // Code Bidi Warning Decorator
  ['span', {
    'data-bidi-component': 'code-bidi-warning-decorator',
    'data-testid': 'code-bidi-warning-decorator',
    'data-bidi-character-code': bidiCharacterCode,
    role: 'mark'
  },
  // Mark the < and > characters as visually hidden for screen readers
  ['span', {
    'aria-hidden': 'true'
  }, '<'], bidiCharacterCode, ['span', {
    'aria-hidden': 'true'
  }, '>']]].concat(_toConsumableArray(tooltipEnabled ? [['span', {
    'data-bidi-component': 'code-bidi-warning-tooltip',
    role: 'tooltip'
  }, codeBidiWarningLabel]] : []));
}